import { memo } from 'react'
import Grid from '@mui/material/Grid'
import { useTheme, useMediaQuery } from '@mui/material'
import ButtonSkeleton from './ButtonSkeleton'

const NavigationButtonsSkeleton = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Grid container spacing={1} direction={isMobile ? 'column-reverse' : 'row'}>
      <Grid item xs={isMobile ? 12 : 4}>
        <ButtonSkeleton />
      </Grid>
      <Grid item xs={isMobile ? 12 : 8}>
        <ButtonSkeleton />
      </Grid>
    </Grid>
  )
}

export default memo(NavigationButtonsSkeleton)
